<div class="container">
    <header>
        <span (click)="close()" class="icon icon-close"></span>
    </header>
    <div class="content">
        <img [src]="data.src" />
    </div>
</div>
